import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const TOKEN_KEY = "spark_admin_token";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token && config.url?.includes("/admin/")) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const fileUrl = (storagePath) => `${API}/files/${storagePath}`;

export const setAdminToken = (token) => {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
};

export const getAdminToken = () => localStorage.getItem(TOKEN_KEY);
